import { useMemo } from 'react';
import { ContentBlockSlug, CustomContent } from '../types';
import { getSanityImageFromString } from '../utils';

export const useSanityImageFromCustomContent = (
  customContent: CustomContent[],
  {
    slug,
    variantKey = ''
  }: {
    slug: ContentBlockSlug;
    /**
     * Provide if searching for a specific "key". Only needed for custom
     * sections that contain multiple images.
     */
    variantKey?: string;
  }
) =>
  useMemo(() => {
    const imageContent = customContent.find((cc) => {
      if (slug && cc.section_slug !== slug) {
        return false;
      }
      const types = cc.content_type?.split('+');
      if (!types || types[0] !== 'media') {
        return false;
      }

      // Ignore types that include mobile-toggle, as they're used to hide/show a
      // separate mobile media form field and only contain boolean data.
      if (types.length > 2 && types[2] === 'mobile-toggle') {
        return false;
      }

      if (variantKey.length) {
        return types[1] === variantKey;
      }
      return true;
    })?.content;

    if (imageContent) {
      return getSanityImageFromString(imageContent);
    }
    return null;
  }, [customContent, slug, variantKey]);
